import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button, FormGroup, FormControl } from 'react-bootstrap';
import { trackPageView, trackEvent } from '../util/Analytics.jsx';
import Utils from '../util/Utils.jsx';
import { useStateValue } from '../context/state.jsx';
import { openAlert } from '../context/alert.js';

const SignInHelpPage = () => {
	const [, dispatch] = useStateValue();
	const [email, setEmail] = useState('');

	useEffect(() => {
		trackPageView();
	}, []);

	const emailChange = e => {
		setEmail(e.target.value);
	};

	const resetPassword = () => {
		trackEvent('account', 'click', 'reset password');
		const postData = { email };
		Utils.ajax(
			'resetPasswordStart',
			postData,
			dispatch,
			result => {
				if (result.success) {
					dispatch(openAlert('Password Reset Started', 'A password reset has been initiated. Please check your email to continue.'));
				} else {
					dispatch(openAlert('Warning', result.error));
				}
			}
		);
	};

	return (
		<div className="signInHelpPage">
			<div className="pageContent">
				<h2>Sign In Help</h2>
				<div>
					<FormGroup className="loginForm">
						<div>
							<FormControl type="email" placeholder="Email" value={email} onChange={emailChange} />
						</div>
						<div><Button block bsStyle="primary" onClick={resetPassword}>Reset Password</Button></div>
						<div>
							<Link to='/signin'>
								<Button>
									<span className="glyphicon glyphicon-arrow-left leftGlyph"></span>
									Back to Sign In
								</Button>
							</Link>
						</div>
					</FormGroup>
				</div>
			</div>
		</div>
	);
};

export default SignInHelpPage;